import { CustomerRegistrationStep, CustomerUserAccessModel } from '@data-access';

/**
 * The customer the owner is still registering (FR8BOT-1278): until it is completed its cabinet
 * answers every call with `CUSTOMER_REGISTRATION_INCOMPLETE`, so the owner belongs in the wizard.
 * An access without a step predates the wizard.
 */
export function customerInRegistration(
  customers: readonly CustomerUserAccessModel[] | undefined,
): CustomerUserAccessModel | undefined {
  return customers?.find(
    (customer) =>
      customer.owner &&
      !!customer.registrationStep &&
      customer.registrationStep !== CustomerRegistrationStep.Completed,
  );
}
